import { useFraudScoreEnabled } from 'features/fraudAnalysis'
import { IdEventV4 } from 'models/event'
import { useMemo } from 'react'

import { getColumnDefinitions } from './columns'
import { useEventsTableCore } from './useEventsTableCore'

/**
 * Wrapper around {@link useEventsTableCore} using the server data strategy. Adds the hidden-by-default
 * Fraud Score column when Fraud Score is enabled for the workspace.
 *
 * **IMPORTANT**: The "Filter by value" cell action is configured via
 * `EventsTableActionsProvider`, not through this hook. When integrating
 * the events table into a new surface:
 * 1. Wrap with `<EventsTableActionsProvider value={{ from: YourRoute.fullPath }}>` to
 *    enable the "Filter by value" cell action
 * 2. Or wrap with `<EventsTableActionsProvider value={{}}>` to explicitly disable
 *    filter actions (and silence the dev warning)
 */
export function useVisitsTable(subscriptionId: string, events?: IdEventV4[]) {
  const { isEnabled: isFraudScoreEnabled } = useFraudScoreEnabled(subscriptionId)
  const columnDefs = useMemo(
    () => getColumnDefinitions({ workspaceId: subscriptionId, isFraudScoreEnabled }),
    [subscriptionId, isFraudScoreEnabled]
  )

  return useEventsTableCore({ mode: 'server', events, subscriptionId }, columnDefs)
}
